(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-push"] && !Shopify.designMode) return;
  try {
    

(function () {

  function scrollAmount(track) {

    var item =
      track.querySelector(
        '.s-product-push__item'
      );

    if (!item) {
      return 0;
    }

    var styles =
      getComputedStyle(track);

    var gap =
      parseFloat(
        styles.columnGap ||
        styles.gap ||
        0
      );

    return (
      item.getBoundingClientRect().width
      + gap
    );
  }

  function initNav(section) {

    var track =
      section.querySelector(
        '.s-product-push__track'
      );

    var prev =
      section.querySelector(
        '[data-direction="prev"]'
      );

    var next =
      section.querySelector(
        '[data-direction="next"]'
      );

    if (!track) {
      return;
    }

    if (prev) {

      prev.addEventListener(
        'click',
        function () {

          track.scrollBy({
            left: -scrollAmount(track),
            behavior: 'smooth'
          });

        }
      );

    }

    if (next) {

      next.addEventListener(
        'click',
        function () {

          track.scrollBy({
            left: scrollAmount(track),
            behavior: 'smooth'
          });

        }
      );

    }

  }

  function initLazyVideos(section) {

    var track =
      section.querySelector(
        '.s-product-push__track'
      );

    var videos =
      section.querySelectorAll(
        '.s-product-push__media-el[autoplay]'
      );

    if (
      !videos.length ||
      !('IntersectionObserver' in window)
    ) {
      return;
    }

    var observer =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(
            function (entry) {

              if (entry.isIntersecting) {

                entry.target
                  .play()
                  .catch(
                    function () {}
                  );

              } else {

                entry.target.pause();

              }

            }
          );

        },
        {
          root: track,
          threshold: 0.4
        }
      );

    videos.forEach(
      function (video) {
        observer.observe(video);
      }
    );

  }

  function initSection(section) {

    if (section.dataset.sppInit) {
      return;
    }

    section.dataset.sppInit = 'true';

    initNav(section);

    initLazyVideos(section);

  }

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      document
        .querySelectorAll(
          '.s-product-push'
        )
        .forEach(initSection);

    }
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var target =
        event.target;

      var section =
        target.matches &&
        target.matches(
          '.s-product-push'
        )
          ? target
          : target.querySelector &&
            target.querySelector(
              '.s-product-push'
            );

      if (section) {
        initSection(section);
      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["santo-quiz-rutina"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('santo-quiz-rutina')) {
    class SantoQuizRutina extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        try {
          this.data = JSON.parse(this.querySelector('[data-quiz-data]').textContent);
        } catch (e) {
          this.data = { rutinas: [], lavados: [] };
        }

        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.questionSteps = this.steps.filter((s) => s.hasAttribute('data-question'));
        this.resultIndex = this.steps.findIndex((s) => s.dataset.step === 'result');
        this.current = 0;
        this.history = [];
        this.answers = {};
        this.storageKey = 'santoQuiz:' + this.dataset.sectionId;

        this.progress = this.querySelector('[data-progress]');
        this.progressText = this.querySelector('[data-progress-text]');
        this.progressBar = this.querySelector('[data-progress-bar]');

        this.addEventListener('click', this.onClick.bind(this));

        const nameInput = this.querySelector('[data-name-input]');
        if (nameInput) {
          nameInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.submitName();
            }
          });
        }

        const form = this.querySelector('.santo-quiz__form');
        if (form) form.addEventListener('submit', this.onSubmit.bind(this));

        if (!this.restore()) this.show(0, false);
      }

      onClick(e) {
        const option = e.target.closest('[data-answer]');
        if (option) {
          this.answers[option.dataset.key] = option.dataset.value;
          option.parentElement.querySelectorAll('[data-answer]').forEach((b) => {
            b.setAttribute('aria-pressed', b === option ? 'true' : 'false');
          });
          this.next();
          return;
        }
        if (e.target.closest('[data-next]')) return this.next();
        if (e.target.closest('[data-name-next]')) return this.submitName();
        if (e.target.closest('[data-back]')) return this.back();
        if (e.target.closest('[data-restart]')) return this.restart();

        const addOne = e.target.closest('[data-add-one]');
        if (addOne) return this.addToCart([addOne.dataset.addOne], addOne);

        const addRoutine = e.target.closest('[data-add-routine]');
        if (addRoutine) {
          const ids = addRoutine.dataset.addRoutine.split(',').filter(Boolean);
          return this.addToCart(ids, addRoutine);
        }

        const copy = e.target.closest('[data-copy-code]');
        if (copy) return this.copyCode(copy);
      }

      submitName() {
        const input = this.querySelector('[data-name-input]');
        const error = this.querySelector('[data-name-error]');
        const value = (input.value || '').trim();
        if (value.length < 2) {
          error.hidden = false;
          input.focus();
          return;
        }
        error.hidden = true;
        this.answers.nombre = value;
        this.next();
      }

      next() {
        const nextIndex = this.current + 1;
        if (nextIndex === this.resultIndex) this.renderResult();
        this.history.push(this.current);
        this.show(nextIndex);
      }

      back() {
        if (!this.history.length) return;
        this.show(this.history.pop());
      }

      restart() {
        this.answers = {};
        this.history = [];
        this.querySelectorAll('[data-answer]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        const nameInput = this.querySelector('[data-name-input]');
        if (nameInput) nameInput.value = '';
        try { sessionStorage.removeItem(this.storageKey); } catch (e) {}
        this.show(0);
      }

      show(index, focus = true) {
        this.current = index;
        this.steps.forEach((step, i) => { step.hidden = i !== index; });

        const step = this.steps[index];
        const qIndex = this.questionSteps.indexOf(step);
        if (qIndex > -1) {
          const total = this.questionSteps.length;
          this.progress.hidden = false;
          this.progressText.textContent = 'Paso ' + (qIndex + 1) + ' de ' + total;
          this.progressBar.style.width = ((qIndex + 1) / total) * 100 + '%';
        } else {
          this.progress.hidden = true;
        }

        if (focus) {
          const title = step.querySelector('.santo-quiz__title');
          if (title) title.focus({ preventScroll: true });
          const rect = this.getBoundingClientRect();
          if (rect.top < 0 || rect.top > window.innerHeight * 0.5) {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }

      renderResult() {
        const a = this.answers;
        const rutina = this.data.rutinas.find((r) => r.tipo === a.tipo && r.grosor === a.grosor) || {};
        const lavado = this.data.lavados.find((l) => l.frecuencia === a.lavado) || {};

        const texts = {
          champu: lavado.texto || '',
          mascarilla: rutina.mascarilla || '',
          conditioner: rutina.conditioner || '',
          serum: rutina.serum || ''
        };
        Object.keys(texts).forEach((role) => {
          const slot = this.querySelector('[data-slot="' + role + '"]');
          if (slot) slot.textContent = texts[role];
        });

        const nameSlot = this.querySelector('[data-name-slot]');
        if (nameSlot) nameSlot.textContent = a.nombre ? ', ' + a.nombre : '';

        const labels = {
          liso: 'Liso', ondulado: 'Ondulado', rizado: 'Rizado',
          fino: 'fino', medio: 'medio', grueso: 'grueso'
        };
        const summary = this.querySelector('[data-summary]');
        if (summary && a.tipo && a.grosor) {
          summary.textContent = 'Cabello ' + labels[a.tipo].toLowerCase() + ' · grosor ' + labels[a.grosor];
        }

        const tagsField = this.querySelector('[data-tags-field]');
        if (tagsField) {
          const tags = ['newsletter', 'quiz-rutina'];
          if (a.tipo) tags.push('quiz-tipo-' + a.tipo);
          if (a.grosor) tags.push('quiz-grosor-' + a.grosor);
          if (a.lavado) tags.push('quiz-lavado-' + a.lavado);
          if (a.secador) tags.push('quiz-secador-' + a.secador);
          if (a.cuero) tags.push('quiz-cuero-' + a.cuero);
          tagsField.value = tags.join(',');
        }
        const firstName = this.querySelector('[data-first-name-field]');
        if (firstName) firstName.value = a.nombre || '';
      }

      onSubmit() {
        this.renderResult();
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({ answers: this.answers, submitted: true }));
        } catch (e) {}
      }

      restore() {
        if (!/customer_posted=true/.test(window.location.search)) return false;
        let saved = null;
        try { saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null'); } catch (e) {}
        if (!saved || !saved.submitted) return false;

        this.answers = saved.answers || {};
        this.renderResult();
        this.show(this.resultIndex, false);
        requestAnimationFrame(() => {
          const signup = this.querySelector('.santo-quiz__signup');
          (signup || this).scrollIntoView({ block: 'center' });
        });
        return true;
      }

      async addToCart(ids, button) {
        const error = this.querySelector('[data-cart-error]');
        if (error) error.hidden = true;
        button.disabled = true;

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
          });
          if (!res.ok) throw new Error('cart');
          window.location.href = this.dataset.cartUrl || '/cart';
        } catch (e) {
          button.disabled = false;
          if (error) error.hidden = false;
        }
      }

      copyCode(button) {
        const codeEl = this.querySelector('[data-code]');
        if (!codeEl) return;
        const code = codeEl.textContent.trim();
        const selectCode = () => {
          const range = document.createRange();
          range.selectNodeContents(codeEl);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            () => { button.textContent = 'Copiado'; },
            selectCode
          );
        } else {
          selectCode();
        }
      }
    }

    customElements.define('santo-quiz-rutina', SantoQuizRutina);
  }

  } catch(e) { console.error(e); }
})();
})();
